import { render, staticRenderFns } from "./MaterialNowList.vue?vue&type=template&id=843a46d6&scoped=true&"
import script from "./MaterialNowList.vue?vue&type=script&lang=js&"
export * from "./MaterialNowList.vue?vue&type=script&lang=js&"
import style0 from "./MaterialNowList.vue?vue&type=style&index=0&id=843a46d6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "843a46d6",
  null
  
)

export default component.exports